import { render, staticRenderFns } from "./navbar-default.vue?vue&type=template&id=398af9f0"
import script from "./navbar-default.vue?vue&type=script&lang=js"
export * from "./navbar-default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavbarItem: require('C:/cata1og/cata1og-store/components/navbar/navbar-item.vue').default})
